import { OrganizationPermissions, UsersPermissions } from '@quadminds/shared/auth-system';
import {
    CarrierPermissions,
    DriverPermissions,
    LocationPermissions,
    OrganizationKeyPermissions,
    StateDefinitionPermissions,
    TagPermissions,
    TripDefinitionPermissions,
    TripPermissions,
    VehiclePermissions,
    ZonePermissions,
} from '@quadminds/shared/commons';

export class PermissionsHelper {
    static getReadPermissions(): string[] {
        return [
            TripPermissions.GetTrips,
            LocationPermissions.GetLocations,
            CarrierPermissions.GetCarriers,
            DriverPermissions.GetDrivers,
            TripDefinitionPermissions.GetTripDefinitions,
            VehiclePermissions.GetVehicles,
            StateDefinitionPermissions.GetStateDefinitions,
            TagPermissions.GetTags,
            ZonePermissions.GetZones,
            OrganizationKeyPermissions.GetOrganizationKeys,
        ];
    }

    static getCreatePermissions(): string[] {
        return [
            TripPermissions.CreateTrip,
            LocationPermissions.CreateLocation,
            CarrierPermissions.CreateCarrier,
            DriverPermissions.CreateDriver,
            TripDefinitionPermissions.CreateTripDefinition,
            VehiclePermissions.CreateVehicle,
            StateDefinitionPermissions.CreateStateDefinition,
            TagPermissions.CreateTag,
            ZonePermissions.CreateZone,
            OrganizationKeyPermissions.CreateOrganizationKey,
        ];
    }

    static getEditPermissions(): string[] {
        return [
            TripPermissions.UpdateTrip,
            LocationPermissions.UpdateLocation,
            CarrierPermissions.UpdateCarrier,
            DriverPermissions.UpdateDriver,
            TripDefinitionPermissions.UpdateTripDefinition,
            VehiclePermissions.UpdateVehicle,
            StateDefinitionPermissions.UpdateStateDefinition,
            TagPermissions.UpdateTag,
            ZonePermissions.UpdateZone,
            OrganizationKeyPermissions.UpdateOrganizationKey,
        ];
    }

    static getDeletePermissions(): string[] {
        return [
            TripPermissions.DeleteTrip,
            LocationPermissions.DeleteLocation,
            CarrierPermissions.DeleteCarrier,
            DriverPermissions.DeleteDriver,
            TripDefinitionPermissions.DeleteTripDefinition,
            VehiclePermissions.DeleteVehicle,
            StateDefinitionPermissions.DeleteStateDefinition,
            TagPermissions.DeleteTag,
            ZonePermissions.DeleteZone,
            OrganizationKeyPermissions.DeleteOrganizationKey,
        ];
    }

    static getOrganizationPermissions(): string[] {
        return [
            OrganizationPermissions.AddInvites,
            OrganizationPermissions.AddUsers,
            OrganizationPermissions.DeleteInvites,
            OrganizationPermissions.DeleteUsers,
            OrganizationPermissions.GetOrganization,
            OrganizationPermissions.ListInvites,
            OrganizationPermissions.UpdateOrganization,
            OrganizationPermissions.UpdateUsers,
            OrganizationPermissions.ListUsers,
            OrganizationPermissions.UpdateInvites,
        ];
    }

    static getUserPermissions(): string[] {
        return [UsersPermissions.DeleteUser, UsersPermissions.GetUser, UsersPermissions.UpdateUser];
    }

    static getLimitedPermissions(): string[] {
        return [
            ...this.getReadPermissions(),
            UsersPermissions.GetUser,
            UsersPermissions.UpdateUser,
            OrganizationPermissions.GetOrganization,
        ];
    }

    static getOrganizationUsersDriversPermissions() {
        return [
            OrganizationPermissions.UpdateDriverUsers,
            OrganizationPermissions.DeleteDriverUsers,
            OrganizationPermissions.OrganizationsInvitesDriversCreate,
            OrganizationPermissions.OrganizationsInvitesDriversUpdate,
            OrganizationPermissions.OrganizationsInvitesDriversDelete,
        ];
    }

    static getAdminPermissions(): string[] {
        return [
            ...this.getReadPermissions(),
            ...this.getCreatePermissions(),
            ...this.getDeletePermissions(),
            ...this.getEditPermissions(),
            ...this.getOrganizationPermissions(),
            ...this.getUserPermissions(),
            ...this.getOrganizationUsersDriversPermissions(),
        ];
    }
}
